<template>
    <div>
        <v-row>
            <v-col cols="12">
                <p>
                Vous avez déjà une demande de candidature ouverte. 
                <br/>
                Merci de vous rendre sur votre espace dédié en renseignant votre login et mot de passe communiqué précédemment par email.                <br/>
                <a :href="LienPortail" target="_blank">Cliquez ici pour vous rediriger vers l'extranet.</a>
                </p>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default{
    data() {
    return {
      LienPortail: process.env.VUE_APP_LIEN_PORTAIL,
    };
  },
}
</script>